import {
  call, put, all, takeLatest, takeEvery,
} from 'redux-saga/effects';
import moment from 'moment';
import { authRequest } from '../../helpers/request.helper';
import {
  GASTOS_GUARDAR_REQUEST,
  GASTOS_GUARDAR_FAILURE,
  GASTOS_GUARDAR_SUCCESS,
} from '../actions/constants/caja.creador.constants';


function* guardarGastos() {
  const formData = new FormData();
  formData.append('tipo', 'P');
  formData.append('hora', '2014-01-30 15:00:00');
  formData.append('gastos', 248);
  formData.append('forma_pago_id', 2);
  formData.append('concepto', 'concepto de prueba');




  try {
    //yield put({ type: GASTOS_GUARDAR_REQUEST });
    const resultado = yield call(authRequest, { url: 'api/caja/guardar', method: 'POST', body:formData });
    yield put({ type: GASTOS_GUARDAR_SUCCESS });
  } catch (e) {
      yield put({ type: GASTOS_GUARDAR_FAILURE});
      return;
  }
  return
}

function* cajaCreadorSaga() {
  yield all([

    yield takeLatest(GASTOS_GUARDAR_REQUEST, guardarGastos),

  ]);
}
export default cajaCreadorSaga;
